import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import TextareaCounter from './../../FormComponents/TextareaCounter';

export default function FitnessChats({
  details,
  onChange,
  disabled,
  softwares,
  errors,
  preferences,
}) {
  const { isSchemaFetched, schema } = preferences;
  const onShowersAvailableChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'showers_available',
        checked: !details.showers_available,
      },
    });
  };

  const onChangingRoomsAvailableChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'changing_rooms_available',
        checked: !details.changing_rooms_available,
      },
    });
  };
  return (
    <div className="chats">
      {schema?.first_message && (
        <div className="chats__row">
          <p className="chats__row__label">
            {schema?.first_message?.description ||
              'What would you like the first text message to your guest to say?'}
            <sup>*</sup>
            <br />
            <span className="hint-text">
              Note: Please don&apos;t enter phone numbers or URLs as part of
              this first message.
            </span>
          </p>
          <div className="mandatory__row__input">
            <TextareaCounter
              rows="3"
              placeholder={`Hello, thanks for calling ${softwares.info
                .STUDIO_NAME ||
                '<name>'}. This is our text-only number for reservations and inquiries.`}
              name="first_message"
              value={details.first_message}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
            {((details.first_message &&
              details.first_message.trim().length < 1) ||
              !details.first_message) && (
              <span className="message--small message--error">
                Please enter a valid first message
              </span>
            )}
          </div>
        </div>
      )}

      {schema?.client_outside_door && (
        <div className="chats__row">
          <p className="chats__row__label">
            {schema?.client_outside_door?.description ||
              'In case a guest is waiting outside, what would you like TrueLark to say?'}
          </p>
          <div className="chats__row__input">
            <TextareaCounter
              rows="3"
              placeholder="I'm sorry about that.
              I've forwarded your message to the stylist and they'll let you in shortly"
              name="client_outside_door"
              value={details.client_outside_door}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {schema?.showers_available && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.showers_available?.description ||
              'Do you have showers at your facility?'}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.showers_available}
              name="showers_available"
              onChange={onShowersAvailableChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {schema?.changing_rooms_available && (
        <div className="special-row">
          <p className="special-row__label">
            {schema?.changing_rooms_available?.description ||
              'Do you have changing rooms?'}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.changing_rooms_available}
              name="changing_rooms_available"
              onChange={onChangingRoomsAvailableChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}
    </div>
  );
}

FitnessChats.defaultProps = {
  onChange: () => {},
  details: {},
  disabled: false,
};

FitnessChats.propTypes = {
  onChange: PropTypes.func,
  details: PropTypes.shape(),
  disabled: PropTypes.bool,
};
